// extracted by mini-css-extract-plugin
export default {"point_name":"Notify_point_name__JR1zz","floating_btn":"Notify_floating_btn__kJwA9","send":"Notify_send__qT2aE","receive":"Notify_receive__BhuJM","btn_wrap":"Notify_btn_wrap__IV3hJ"};